var import_VideoComponent = require("../../VideoComponent.css");
"use strict";
Object.defineProperties(exports, { __esModule: { value: true }, [Symbol.toStringTag]: { value: "Module" } });
const vue = require("vue");
const util_Lightbox = require("../../Lightbox-bc16ff55.js");
const play = require("../../play-465a60ac.js");
const mq = require("../../mq-196b9a1d.js");
const _pluginVue_exportHelper = require("../../_plugin-vue_export-helper-9c783a34.js");
const _hoisted_1 = { class: "video__container" };
const _hoisted_2 = ["href"];
const _hoisted_3 = { class: "sr-only" };
const _hoisted_4 = { class: "video__play" };
const _hoisted_5 = ["src", "srcset"];
const _hoisted_6 = ["id"];
const _hoisted_7 = ["id"];
const _sfc_main = /* @__PURE__ */ vue.defineComponent({
  props: {
    url: null,
    poster: { default: "" },
    poster2x: { default: "" },
    poster3x: { default: "" },
    fallback: { type: Boolean, default: true },
    showInLightbox: { type: Boolean, default: false },
    videoRatio: { default: "16by9" },
    uuid: { default: "" },
    buttonColor: { default: "black" }
  },
  setup(__props) {
    const props = __props;
    let thumbUrlRef = vue.ref("");
    let isPlaying = vue.ref(false);
    let embed = vue.ref(null);
    const lightbox = vue.ref(null);
    const rootRef = vue.ref(null);
    const posterSrcSet = vue.computed(() => {
      let value = "";
      if (props.poster3x && props.poster3x.length > 0) {
        value += `${props.poster3x} 1440w,`;
      }
      if (props.poster2x && props.poster2x.length > 0) {
        value += `${props.poster2x} 960w,`;
      }
      if (props.poster && props.poster.length > 0) {
        value += `${props.poster} 480w,`;
      }
      return value;
    });
    const posterSrc = vue.computed(() => {
      return props.poster || thumbUrlRef.value;
    });
    vue.onMounted(() => {
      if (!props.url) {
        return;
      }
      embed.value = util_Lightbox.createEmbedConfig(props.url);
      if (!embed) {
        return;
      }
      setEmbedThumbAsVideoPoster();
      const embedTarget = rootRef.value.querySelector(".embed-responsive-item");
      embed.value.on("play", () => {
        playHandler();
      });
      embed.value.on("pause", () => {
        pauseHandler();
      });
      embed.value.initPlayer(embedTarget);
    });
    const setEmbedThumbAsVideoPoster = () => {
      if (props.fallback) {
        if (!embed.value) {
          return;
        }
        embed.value.getThumb().then((thumbUrl) => {
          if (thumbUrl) {
            thumbUrlRef.value = thumbUrl;
          }
        });
      }
    };
    const posterClick = (e) => {
      e.preventDefault();
      if (!embed.value) {
        return;
      }
      if (props.showInLightbox && mq.mqMinWidth("lg").matches) {
        lightbox.value.open();
      } else {
        embed.value.play();
        playHandler();
      }
    };
    const playHandler = () => {
      isPlaying.value = true;
    };
    const pauseHandler = () => {
      isPlaying.value = false;
    };
    return (_ctx, _cache) => {
      return vue.openBlock(), vue.createElementBlock("div", {
        ref_key: "rootRef",
        ref: rootRef,
        class: vue.normalizeClass([[{ "video--playing": vue.unref(isPlaying) }, `video--${__props.buttonColor}`], "video"])
      }, [
        vue.createElementVNode("div", _hoisted_1, [
          vue.unref(posterSrc) && (vue.unref(posterSrc).length > 0 || __props.buttonColor !== "none") ? (vue.openBlock(), vue.createElementBlock("a", {
            key: 0,
            href: __props.url,
            class: "video__poster",
            rel: "noopener",
            target: "_blank",
            onClick: posterClick
          }, [
            vue.createElementVNode("span", _hoisted_3, "Play video " + vue.toDisplayString(__props.url), 1),
            vue.createElementVNode("div", _hoisted_4, [
              vue.createVNode(vue.unref(play.PlayIcon))
            ]),
            vue.unref(posterSrc) && vue.unref(posterSrc).length > 0 ? (vue.openBlock(), vue.createElementBlock("img", {
              key: 0,
              src: vue.unref(posterSrc),
              srcset: vue.unref(posterSrcSet),
              alt: "video poster"
            }, null, 8, _hoisted_5)) : vue.createCommentVNode("", true)
          ], 8, _hoisted_2)) : vue.createCommentVNode("", true),
          vue.createElementVNode("div", {
            id: `video-${__props.uuid}`,
            ref: "videoEmbed",
            class: vue.normalizeClass([`embed-responsive-${__props.videoRatio}`, "embed-responsive"])
          }, [
            vue.createElementVNode("div", {
              id: `video-${__props.uuid}-target`,
              class: "embed-responsive-item"
            }, null, 8, _hoisted_7)
          ], 10, _hoisted_6)
        ]),
        (vue.openBlock(), vue.createBlock(vue.Teleport, { to: "body" }, [
          __props.showInLightbox ? (vue.openBlock(), vue.createBlock(util_Lightbox.Lightbox, {
            key: 0,
            ref_key: "lightbox",
            ref: lightbox,
            content: __props.url || ""
          }, null, 8, ["content"])) : vue.createCommentVNode("", true)
        ]))
      ], 2);
    };
  }
});
const VideoComponent_vue_vue_type_style_index_0_scoped_640e6135_lang = "";
const VideoComponent = /* @__PURE__ */ _pluginVue_exportHelper._export_sfc(_sfc_main, [["__scopeId", "data-v-640e6135"]]);
exports.default = VideoComponent;
